import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute } from "@angular/router";
import { Service } from "../../../../models/service";
import { ServiceControllerService } from "../../../../services/service-controller/service-controller.service";
import { GuideTypesEnum } from "../../../../models/guideTypes";
import { ServiceProperties } from "../../../../models/service-properties";
import {BotControllerService} from "../../../../services/role-controller/bot-controller.service";
import {Bot} from "../../../../models/bot";
import {TranslatedBaseError} from "../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "service-configuration",
  templateUrl: "./service-configuration.component.html",
  providers: [ServiceControllerService, ToastrService, BotControllerService],
})
export class ServiceConfigurationComponent extends TranslatedBaseError implements OnInit {

  public serviceId: string;
  public service: Service;
  public services: any[];
  public isLoading: boolean = false;
  public guideTypesEnum = GuideTypesEnum;
  public guideTypesOptions = [];
  public readonly guide: string = "Guide";
  public readonly pages: string = "Pages";
  public readonly publishing: string = "Publishing";
  public readonly buttons: string = "Buttons";
  public bots: Bot[] = [];

  constructor(private serviceControllerService: ServiceControllerService,
              public toastr: ToastrService,
              public translateService: TranslateService,
              private botService: BotControllerService,
              private route: ActivatedRoute) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.parent.params.subscribe((params) => {
      this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
      if (this.serviceId !== null) {
        this.loadService();
        this.loadBots();
      } else {
        this.service = new Service();
      }
    });
    if (this.guideTypesEnum) {
      this.guideTypesOptions = Object.keys(this.guideTypesEnum);
    }
  }

  public saveService() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.serviceControllerService.saveService(this.service, null).subscribe(
        (data) => {
          this.responseSuccessful("Publishing options saved");
        },
        (error) => this.showErrorMessage(error),
        () => this.isLoading = false,
      );
    }
  }

  public loadService() {
    this.serviceControllerService.getService(this.serviceId).subscribe(
      (data: Service) => {
        this.service = data;
        if (!data.serviceJsonProperties) {
          this.service.serviceJsonProperties = new ServiceProperties();
        }
        console.log(this.service.serviceJsonProperties);
        if (!this.service.serviceJsonProperties.guideType) {
          this.service.serviceJsonProperties.guideType = this.guideTypesOptions[2];
        }
      },
    );
  }

  public loadBots() {
    if (this.serviceId) {
      this.botService.getServicePrintingBots(this.serviceId).subscribe(
          (data) => {
            this.bots = data;
          },
      );
    }
  }
}
